import React from "react";

import {ThemeChildrenContainer, ThemeContainer, ThemeContent} from "./CustomerTheme.styles";
import {Loading} from "../../_defaultComponents/Loading/Loading";

export const CustomerTheme = ({content}) => {
    return (
        <ThemeContainer>
            <Loading />
            <ThemeContent>
                <ThemeChildrenContainer>{content}</ThemeChildrenContainer>
            </ThemeContent>
        </ThemeContainer>
    );
};
